import { config } from 'shared/config';

export const VISUAL_DATA_ENDPOINTS = {
    matrix: {endpoint: config.API_URL + '/api/matrices/data', param: 'visualId'},
    declarativeChart: {endpoint: config.API_URL + '/api/declarativeCharts/data', param: 'visualId'},
    barGraph: { endpoint: `${config.API_URL}/api/bargraphs/data`, param: 'barGraphId' },
    barChart: { endpoint: `${config.API_URL}/api/bargraphs/data`, param: 'barGraphId' },
    lineGraph: { endpoint: `${config.API_URL}/api/linegraphs/data`, param: 'lineGraphId' },
    dataTable: { endpoint: `${config.API_URL}/api/datatables/data`, param: 'dataTableId' },
    pieChart: { endpoint: `${config.API_URL}/api/piecharts/data`, param: 'pieChartId' },
    scatterPlot: { endpoint: `${config.API_URL}/api/scatterplots/data`, param: 'scatterPlotId' },
    dataCard: { endpoint: `${config.API_URL}/api/datacards/data`, param: 'dataCardId' },
} as const;

export type VisualDataEndpointKey = keyof typeof VISUAL_DATA_ENDPOINTS;

export const VISUAL_UPDATE_ENDPOINTS = {
    matrix: config.API_URL + '/api/matrices/update',
    declarativeChart: config.API_URL + '/api/declarativeCharts/update',
    barGraph: `${config.API_URL}/api/barGraphs/update`,
    barChart: `${config.API_URL}/api/barGraphs/update`,
    lineGraph: `${config.API_URL}/api/lineGraphs/update`,
    pieChart: `${config.API_URL}/api/pieCharts/update`,
    scatterPlot: `${config.API_URL}/api/scatterPlots/update`,
    dataTable: `${config.API_URL}/api/dataTables/update`,
    dataCard: `${config.API_URL}/api/dataCards/update`,
    textBox: `${config.API_URL}/api/textboxes/update`,
    shape: `${config.API_URL}/api/shapes/update`,
} as const;

export const VISUAL_DELETE_ENDPOINTS = {
    matrix: config.API_URL + '/api/matrices/delete',
    declarativeChart: config.API_URL + '/api/declarativecharts/delete',
    barGraph: `${config.API_URL}/api/bargraphs/delete`,
    barChart: `${config.API_URL}/api/bargraphs/delete`,
    lineGraph: `${config.API_URL}/api/linegraphs/delete`,
    pieChart: `${config.API_URL}/api/piecharts/delete`,
    scatterPlot: `${config.API_URL}/api/scatterplots/delete`,
    dataTable: `${config.API_URL}/api/datatables/delete`,
    dataCard: `${config.API_URL}/api/datacards/delete`,
} as const;

export const MANUAL_VISUAL_CREATE_ENDPOINTS = {
    textBox: `${config.API_URL}/api/textboxes/add`,
    shape: `${config.API_URL}/api/shapes/add`,
} as const;

export const MANUAL_VISUAL_UPDATE_ENDPOINTS = {
    textBox: `${config.API_URL}/api/textboxes/update`,
    shape: `${config.API_URL}/api/shapes/update`,
} as const;

export const MANUAL_VISUAL_DELETE_ENDPOINTS = {
    textBox: `${config.API_URL}/api/textboxes/delete`,
    shape: `${config.API_URL}/api/shapes/delete`,
} as const;
